require("./bootstrap");

window.Vue = require("vue");

import VeeValidate, { Validator } from "vee-validate";
import notyModal from "./components/element/notyModal.vue";
import es from "vee-validate/dist/locale/es";
import vSelect from "vue-select";
import VModal from "vue-js-modal";
import VuePrism from "vue-prism";
import Tabs from "vue-tabs-component";
import vueSmoothScroll from "vue-smooth-scroll";
import VueGoodTable from "vue-good-table";
import VueAutosize from "vue-autosize";
import { Money } from "v-money";
import VueTheMask from "vue-the-mask";
import Cleave from "vue-cleave-component";
import Loader from "./components/element/Loader.vue";
import Multiselect from "vue-multiselect";
import VueCtkDateTimePicker from "vue-ctk-date-time-picker";
import "vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css";
import Chartkick from "vue-chartkick";
import Chart from "chart.js";
import Vuesax from "vuesax";
import "vuesax/dist/vuesax.css";
import "material-icons/iconfont/material-icons.css";
import carousel from "vue-owl-carousel";
import Vue from "vue";

Validator.localize("es", es);

/// Init
Vue.use(Chartkick.use(Chart));
Vue.use(VeeValidate);
Vue.use(VModal);
Vue.use(VuePrism);
Vue.use(Tabs);
Vue.use(VueGoodTable);
Vue.use(Cleave);
Vue.use(VueTheMask);
Vue.use(vueSmoothScroll);
Vue.use(VueAutosize);
Vue.component("VueCtkDateTimePicker", VueCtkDateTimePicker);

Vue.use(Vuesax, {
  // options here
});

/// Componentes
Vue.component("carousel", carousel);
Vue.component("notymodal", notyModal);
Vue.component("multiselect", Multiselect);
Vue.component("v-select", vSelect);
Vue.component(
  "expandableContentButton",
  require("./components/element/ExpandableContentButton.vue")
);
Vue.component(
  "expandableContentCheckbox",
  require("./components/element/ExpandableContentCheckbox.vue")
);
Vue.component("ButtonCard", require("./components/element/ButtonCard.vue"));
Vue.component("money", Money);
Vue.component("input-field", require("./components/element/InputField.vue"));
Vue.component("infoBox", require("./components/element/InfoBox.vue"));
Vue.component(
  "transitionCharts",
  require("./components/element/TransitionCharts.vue")
);
Vue.component(
  "textarea-field",
  require("./components/element/TextareaField.vue")
);
Vue.component("dropdown", require("./components/element/Dropdown.vue"));
Vue.component(
  "dropdown-notification",
  require("./components/element/DropdownNotification.vue")
);
Vue.component("fileUpload2", require("./components/element/FileUpload2.vue"));
Vue.component(
  "notificaciones",
  require("./components/element/Notificaciones.vue")
);
Vue.component(
  "consultaCierreComisiones",
  require("./components/forms/cierre-comisiones/ConsultaCierreComisiones.vue")
);
Vue.component(
  "cierreComisiones",
  require("./components/forms/cierre-comisiones/CierreComisiones.vue")
);
Vue.component(
  "itemCierreComisiones",
  require("./components/forms/cierre-comisiones/ItemCierreComisiones.vue")
);
Vue.component(
  "cambiarVendedor",
  require("./components/forms/cierre-comisiones/CambiarVendedor.vue")
);
Vue.component("notification", require("./components/element/Notification.vue"));
Vue.component("loader", Loader);
Vue.component("kTable", require("./components/element/KTable.vue"));
Vue.component("datePicker", require("./components/element/DatePicker.vue"));
Vue.component(
  "checkedListbox",
  require("./components/element/CheckedListbox.vue")
);
Vue.component("dynamicTable", require("./components/element/DynamicTable.vue"));

/// Layout
Vue.component("kp-header", require("./components/layout/Header.vue"));
Vue.component("kp-logo", require("./components/layout/Logo.vue"));
Vue.component("kp-menu", require("./components/layout/menu/MainMenu.vue"));
Vue.component("kp-submenu", require("./components/layout/menu/Submenu.vue"));
Vue.component("kp-support", require("./components/layout/Support.vue"));
Vue.component("menu-search", require("./components/layout/menu/Search.vue"));
Vue.component("kp-user", require("./components/layout/UserStatus.vue"));

/// Personas
Vue.component(
  "persona",
  require("./components/forms/mantenimiento/personas/Persona.vue")
);
Vue.component(
  "listaPersonas",
  require("./components/forms/mantenimiento/personas/ListaPersonas.vue")
);

//Items
Vue.component(
  "item",
  require("./components/forms/mantenimiento/items/Item.vue")
);
Vue.component(
  "listaItem",
  require("./components/forms/mantenimiento/items/ListaItem.vue")
);
Vue.component(
  "reporteItems",
  require("./components/forms/reportes/ReporteItems.vue")
);

//Tipos de unidad
Vue.component(
  "tipoUnidad",
  require("./components/forms/mantenimiento/tipos-unidad/TipoUnidad.vue")
);
Vue.component(
  "listaTiposUnidad",
  require("./components/forms/mantenimiento/tipos-unidad/ListaTiposUnidad.vue")
);

/// Comprobantes
Vue.component(
  "itemComprobante",
  require("./components/forms/comprobantes/ItemComprobante.vue")
);
Vue.component(
  "comprobante",
  require("./components/forms/comprobantes/Comprobante.vue")
);
Vue.component(
  "tablaFormaPago",
  require("./components/forms/comprobantes/TablaFormaPago.vue")
);
Vue.component(
  "tablaInformacionAdicional",
  require("./components/forms/comprobantes/TablaInformacionAdicional.vue")
);
Vue.component(
  "tablaDetalleComprobante",
  require("./components/forms/comprobantes/TablaDetalleComprobante.vue")
);
Vue.component(
  "listaComprobantes",
  require("./components/forms/comprobantes/ListaComprobantes.vue")
);
Vue.component(
  "coincidenciaComprobantes",
  require("./components/forms/comprobantes/CoincidenciaComprobantes.vue")
);
Vue.component(
  "retencion",
  require("./components/forms/comprobantes/Retencion.vue")
);
Vue.component(
  "tablaDetalleRetencion",
  require("./components/forms/comprobantes/TablaDetalleRetencion.vue")
);
Vue.component(
  "itemRetencion",
  require("./components/forms/comprobantes/ItemRetencion.vue")
);
Vue.component(
  "listaAbonos",
  require("./components/forms/comprobantes/ListaAbonos.vue")
);
Vue.component("abono", require("./components/forms/comprobantes/Abono.vue"));
Vue.component(
  "autorizacionDocumentos",
  require("./components/forms/comprobantes/Autorizacion.vue")
);
Vue.component(
  "eventosComprobante",
  require("./components/forms/comprobantes/EventosComprobante.vue")
);
Vue.component("logs", require("./components/forms/comprobantes/Logs.vue"));
Vue.component(
  "filtroComprobantes",
  require("./components/forms/comprobantes/FiltroComprobantes.vue")
);
Vue.component(
  "consultaComprobantes",
  require("./components/forms/portal-cautivo/ConsultaComprobantes.vue")
);
Vue.component(
  "imprimir",
  require("./components/forms/comprobantes/Imprimir.vue")
);
Vue.component(
  "guiaRemision",
  require("./components/forms/comprobantes/GuiaRemision.vue")
);
Vue.component(
  "tablaDetalleGuiaRemision",
  require("./components/forms/comprobantes/TablaDetalleGuiaRemision.vue")
);
Vue.component(
  "detalleGuiaRemision",
  require("./components/forms/comprobantes/DetalleGuiaRemision.vue")
);
Vue.component(
  "tablaItemGuiaRemision",
  require("./components/forms/comprobantes/TablaItemGuiaRemision.vue")
);
Vue.component(
  "itemGuiaRemision",
  require("./components/forms/comprobantes/ItemGuiaRemision.vue")
);
Vue.component(
  "itemsComprobante",
  require("./components/forms/comprobantes/ItemsComprobante.vue")
);
Vue.component(
  "alertas",
  require("./components/forms/comprobantes/Alertas.vue")
);
Vue.component(
  "reporteVentas",
  require("./components/forms/reportes/ReporteVentas.vue")
);
Vue.component(
  "tablaReporteVentas",
  require("./components/forms/reportes/TablaReporteVentas.vue")
);
Vue.component(
  "tablaLogsReporteVentas",
  require("./components/forms/reportes/TablaLogsReporteVentas.vue")
);

Vue.component(
  "proforma",
  require("./components/forms/comprobantes/Proforma.vue")
);
Vue.component(
  "tablaItemsProforma",
  require("./components/forms/comprobantes/TablaItemsProforma.vue")
);
Vue.component(
  "itemProforma",
  require("./components/forms/comprobantes/ItemProforma.vue")
);
Vue.component(
  "reporteMasVendidos",
  require("./components/forms/reportes/ReporteMasVendidos.vue")
);
Vue.component(
  "tablaMasVendidos",
  require("./components/forms/reportes/TablaMasVendidos.vue")
);
/// Parametrización
Vue.component(
  "parametrosGeneral",
  require("./components/forms/mantenimiento/parametrizacion/ParametrosGeneral.vue")
);
Vue.component(
  "parametrosBillBot",
  require("./components/forms/mantenimiento/parametrizacion/ParametrosMyBillBot.vue")
);
Vue.component(
  "parametrosPreferencias",
  require("./components/forms/mantenimiento/parametrizacion/ParametrosPreferencias.vue")
);
Vue.component(
  "comisiones",
  require("./components/forms/mantenimiento/parametrizacion/comisiones/Comisiones.vue")
);
Vue.component(
  "ComisionUtilidad",
  require("./components/forms/mantenimiento/parametrizacion/comisiones/ComisionUtilidad.vue")
);
Vue.component(
  "ComisionVenta",
  require("./components/forms/mantenimiento/parametrizacion/comisiones/ComisionVenta.vue")
);

//Localidades
Vue.component(
  "localidad",
  require("./components/forms/mantenimiento/localidades/Localidad.vue")
);
Vue.component(
  "puntoEmision",
  require("./components/forms/mantenimiento/localidades/PuntoEmision.vue")
);
Vue.component(
  "TablaPuntoEmision",
  require("./components/forms/mantenimiento/localidades/TablaPuntoEmision.vue")
);
Vue.component(
  "ListaLocalidades",
  require("./components/forms/mantenimiento/localidades/ListaLocalidades.vue")
);

//Impuestos
Vue.component(
  "impuesto",
  require("./components/forms/mantenimiento/impuestos/Impuesto.vue")
);
Vue.component(
  "listaImpuestos",
  require("./components/forms/mantenimiento/impuestos/ListaImpuestos.vue")
);

//Categorias
Vue.component(
  "categoria",
  require("./components/forms/mantenimiento/categorias/Categoria.vue")
);
Vue.component(
  "listaCategorias",
  require("./components/forms/mantenimiento/categorias/ListaCategorias.vue")
);

//Marcas
Vue.component(
  "marca",
  require("./components/forms/mantenimiento/marcas/Marca.vue")
);
Vue.component(
  "listaMarcas",
  require("./components/forms/mantenimiento/marcas/ListaMarcas.vue")
);

//Vendedores
Vue.component(
  "vendedor",
  require("./components/forms/mantenimiento/vendedores/Vendedor.vue")
);
Vue.component(
  "listaVendedores",
  require("./components/forms/mantenimiento/vendedores/ListaVendedores.vue")
);

//MyBillBot
Vue.component("myBillBot", require("./components/forms/compras/MyBillBot.vue"));

//Compras
Vue.component(
  "reporteAbonosCompra",
  require("./components/forms/compras/ReporteAbonosCompra.vue")
);
Vue.component(
  "comprobanteCompra",
  require("./components/forms/compras/ComprobanteCompra.vue")
);
Vue.component(
  "cabeceraCompra",
  require("./components/forms/compras/CabeceraCompra.vue")
);
Vue.component(
  "listaComprobantesCompra",
  require("./components/forms/compras/ListaComprobantesCompra.vue")
);
Vue.component(
  "retencionVenta",
  require("./components/forms/compras/Retencion.vue")
);
Vue.component(
  "logsSmtpAlertas",
  require("./components/forms/reportes/LogsSmtpAlertas.vue")
);

//Usuarios
Vue.component(
  "administracionUsuarios",
  require("./components/forms/mantenimiento/usuarios/AdministracionUsuarios.vue")
);
Vue.component(
  "usuarioEmpresa",
  require("./components/forms/mantenimiento/usuarios/UsuarioEmpresa.vue")
);
Vue.component(
  "tablaUsuarioEmpresa",
  require("./components/forms/mantenimiento/usuarios/TablaUsuarioEmpresa.vue")
);
Vue.component(
  "crearEditarUsuario",
  require("./components/forms/mantenimiento/usuarios/CrearEditarUsuario.vue")
);

Vue.component(
  "auditorias",
  require("./components/forms/comprobantes/Auditorias.vue")
);

Vue.component("KDashboard", require("./components/KDashboard.vue"));
Vue.component("DashboardAutorizacionDocumentos", require("./components/DashboardAutorizacionDocumentos.vue"));

//Ordenes de trabajo

Vue.component(
  "ordenTrabajo",
  require("./components/forms/ordenes-trabajo/OrdenTrabajo.vue")
);
Vue.component(
  "observacionOt",
  require("./components/forms/ordenes-trabajo/ObservacionOT.vue")
);
Vue.component(
  "reporteOrdenesTrabajo",
  require("./components/forms/ordenes-trabajo/ReporteOrdenesTrabajo.vue")
);
Vue.component(
  "listaOrdenesTrabajo",
  require("./components/forms/ordenes-trabajo/ListaOrdenesTrabajo.vue")
);
Vue.component(
  "notificacionesOt",
  require("./components/element/NotificacionesOt.vue")
);
//zona geografica
Vue.component(
  "zonaGeografica",
  require("./components/forms/mantenimiento/zona-geografica/ZonaGeografica.vue")
);
Vue.component(
  "provincia",
  require("./components/forms/mantenimiento/zona-geografica/Provincia.vue")
);
Vue.component(
  "ciudad",
  require("./components/forms/mantenimiento/zona-geografica/Ciudad.vue")
);
Vue.component(
  "codigoVerificacion",
  require("./components/forms/codigo-verificacion/CodigoVerificacion.vue")
);
// Terminos y condiciones
Vue.component(
  "consultaTerminosCondiciones",
  require("./components/forms/terminos-condiciones/ConsultaTerminosCondiciones.vue")
);
Vue.component(
  "terminosCondiciones",
  require("./components/forms/terminos-condiciones/TerminosCondiciones.vue")
);
Vue.component(
  "listaTerminosCondiciones",
  require("./components/forms/terminos-condiciones/ListaTerminosCondiciones.vue")
);
Vue.component(
  "aceptarTerminosCondiciones",
  require("./components/forms/terminos-condiciones/AceptarTerminosCondiciones.vue")
);
Vue.component(
  "proyectos",
  require("./components/forms/procesos/Proyectos.vue")
);
Vue.component(
  "listaProyectos",
  require("./components/forms/procesos/ListaProyectos.vue")
);
Vue.component(
  "costoProyecto",
  require("./components/forms/procesos/CostoProyecto.vue")
);
Vue.component(
  "listaCostoProyectos",
  require("./components/forms/procesos/ListaCostoProyectos.vue")
);
Vue.component(
  "reporteProyectos",
  require("./components/forms/reportes/ReporteProyectos.vue")
);


//Liquidaciones de compras

Vue.component(
  "liquidacionCompra",
  require("./components/forms/comprobantes/LiquidacionCompra.vue")
);

/// Mixins
Vue.mixin({
  methods: {
    route: route,
  },
});

axios.interceptors.request.use(
  function(config) {
    let id = uuid();
    let Modal = Vue.extend(Loader);
    let ModalComponent = new Modal({
      propsData: {
        name: id,
        loading: true,
      },
    }).$mount();
    app.$refs.app.appendChild(ModalComponent.$el);
    config.component = ModalComponent;
    config.id = id;
    app.$modal.show(id);
    return config;
  },
  function(error) {
    app.$modal.hide(error.config.id);
    return Promise.reject(error);
  }
);

axios.interceptors.response.use(
  function(response) {
    app.$modal.hide(response.config.id);
    return response;
  },
  function(error) {
    app.$modal.hide(error.config.id);
    return Promise.reject(error);
  }
);

const app = new Vue({
  el: "#app",
});



// WEBPACK FOOTER //
// ./resources/assets/js/app.js